/**
 * Weekly menu storage (localStorage), shared by the recipe page button
 * (engage.js) and the menu page (menu.js).
 * Entries: { g: recipe translation-group ID, f: servings factor, d: day 0–6 or -1 }.
 */

export const MENU = 'smakota-menu';
export const MAX_MENU = 21;

export function readMenu() {
	try {
		const v = JSON.parse( window.localStorage.getItem( MENU ) || '[]' );
		return Array.isArray( v )
			? v
					.filter( ( m ) => m && Number( m.g ) )
					.map( ( m ) => ( {
						g: Number( m.g ),
						f: Number( m.f ) || 1,
						d: Number.isInteger( m.d ) ? m.d : -1,
					} ) )
			: [];
	} catch ( e ) {
		return [];
	}
}

export function writeMenu( list ) {
	try {
		window.localStorage.setItem( MENU, JSON.stringify( list ) );
	} catch ( e ) {
		// Storage blocked: the menu is not remembered.
	}
}
